import React from 'react';
import { Placement } from 'tippy.js';
import { Box, BoxProps } from '../../Box/Box';
import { Tooltip } from '../../Tooltip/Tooltip';
import { Text } from '../../Text/Text';
import { Dot } from '../../Dot/Dot';

interface Props extends BoxProps {
  dotBorderColor?: string;
  dotColor?: string;
  isTextTruncated?: boolean;
  text: string;
  tooltipContent?: string;
  tooltipPlacement?: Placement;
}

export const LegendKey = ({
  dotColor = 'primary.300',
  dotBorderColor,
  isTextTruncated,
  text,
  tooltipContent,
  ...rest
}: Props) => {
  return (
    <Tooltip content={tooltipContent} disabled={!tooltipContent}>
      <Box display="flex" alignItems="center" {...rest}>
        <Dot bg={dotColor} borderColor={dotBorderColor} mr="4" />
        <Text fontSize="small" fontWeight={500} color="neutral.600" isTruncated={isTextTruncated}>
          {text}
        </Text>
      </Box>
    </Tooltip>
  );
};
